
export const optionsPlan = [
    { value: 'Pmi', label: 'Pmi' },
    { value: 'Pmi Soltero', label: 'Pmi Soltero' },
    { value: 'Pmi 2000', label: 'Pmi 2000' },
    { value: 'Pmi 3000', label: 'Pmi 3000' },
    { value: 'Pmi 2000 Jubilado', label: 'Pmi 2000 Jubilado' },
    { value: 'Pmi 2000 Monotributo', label: 'Pmi Monotributo' },
    { value: 'Pmi 2886', label: 'Pmi 2886' },
    { value: 'Pmi 2886 2000', label: 'Pmi 2886 2000' },
    { value: 'Pmi 2886 3000', label: 'Pmi 2886 3000' },
    { value: 'Pmi 2886 Soltero', label: 'Pmi 2886 Soltero' },
    { value: 'Pmi 3000 Jubilado', label: 'Pmi 3000 Jubilado' },
    { value: 'Pmi Jubilado', label: 'Pmi Jubilado' },
    { value: 'Pmi Monotributo', label: 'Pmi Monotributo' },
    { value: 'Pmi Monotributo Soltero', label: 'Pmi Monotributo Soltero' },
    { value: 'Pmi 3000 Jubilado', label: 'Pmi 3000 Jubilado' }
]


export const optionsCuotas = [
    { value: '12', label: '12' },
    { value: '11', label: '11' },
    { value: '10', label: '10' },
    { value: '9', label: '9' },
    { value: '8', label: '8' },
    { value: '7', label: '7' },
    { value: '6', label: '6' },
    { value: '5', label: '5' },
    { value: '4', label: '4' },
    { value: '3', label: '3' },
    { value: '2', label: '2' },
    { value: '1', label: '1' }
]


const optionsMontosPmi = [
    { value: '5000', label: '5.000' },
    { value: '10000', label: '10.000' },
    { value: '20000', label: '20.000' },
    { value: '40000', label: '40.000' },
    { value: '60000', label: '60.000' },
    { value: '80000', label: '80.000' },
    { value: '100000', label: '100.000' },
    { value: '120000', label: '120.000' },
    { value: '140000', label: '140.000' },
    { value: '160000', label: '160.000' },
    { value: '180000', label: '180.000' },
    { value: '200000', label: '200.000' },
    { value: '210000', label: '210.000' },
    { value: '220000', label: '220.000' },
    { value: '240000', label: '240.000' },
    { value: '260000', label: '260.000' },
    { value: '280000', label: '280.000' },
    { value: '300000', label: '300.000' },
    { value: '320000', label: '320.000' },
    { value: '340000', label: '340.000' },
    { value: '360000', label: '360.000' },
    { value: '380000', label: '380.000' },
    { value: '400000', label: '400.000' },
    { value: '420000', label: '420.000' },
    { value: '440000', label: '440.000' },
    { value: '460000', label: '460.000' },
    { value: '480000', label: '480.000' },
    { value: '500000', label: '500.000' },
    { value: '520000', label: '520.000' },
    { value: '540000', label: '540.000' },
    { value: '560000', label: '560.000' },
    { value: '580000', label: '580.000' },
    { value: '600000', label: '600.000' }
]

const optionsMontosPmi2000 = [
    { value: '5000', label: '5.000' },
    { value: '10000', label: '10.000' },
    { value: '20000', label: '20.000' },
    { value: '40000', label: '40.000' },
    { value: '60000', label: '60.000' },
    { value: '80000', label: '80.000' },
    { value: '100000', label: '100.000' },
    { value: '120000', label: '120.000' },
    { value: '140000', label: '140.000' },
    { value: '160000', label: '160.000' },
    { value: '180000', label: '180.000' },
    { value: '200000', label: '200.000' },
    { value: '210000', label: '210.000' },
    { value: '220000', label: '220.000' },
    { value: '240000', label: '240.000' },
    { value: '260000', label: '260.000' },
    { value: '280000', label: '280.000' },
    { value: '300000', label: '300.000' },
    { value: '320000', label: '320.000' },
    { value: '340000', label: '340.000' },
    { value: '360000', label: '360.000' },
    { value: '380000', label: '380.000' },
    { value: '400000', label: '400.000' },
    { value: '420000', label: '420.000' },
    { value: '440000', label: '440.000' },
    { value: '460000', label: '460.000' },
    { value: '480000', label: '480.000' },
    { value: '500000', label: '500.000' },
    { value: '520000', label: '520.000' },
    { value: '540000', label: '540.000' },
    { value: '560000', label: '560.000' },
    { value: '580000', label: '580.000' },
    { value: '600000', label: '600.000' },
    { value: '620000', label: '620.000' },
    { value: '640000', label: '640.000' },
    { value: '650000', label: '660.000' },
    { value: '680000', label: '680.000' },
    { value: '700000', label: '700.000' },
    { value: '720000', label: '720.000' },
    { value: '740000', label: '740.000' },
    { value: '760000', label: '760.000' },
    { value: '780000', label: '780.000' }
]


const optionsMontosPmi3000 = [
    { value: '5000', label: '5.000' },
    { value: '10000', label: '10.000' },
    { value: '20000', label: '20.000' },
    { value: '40000', label: '40.000' },
    { value: '60000', label: '60.000' },
    { value: '80000', label: '80.000' },
    { value: '100000', label: '100.000' },
    { value: '120000', label: '120.000' },
    { value: '140000', label: '140.000' },
    { value: '160000', label: '160.000' },
    { value: '180000', label: '180.000' },
    { value: '200000', label: '200.000' },
    { value: '210000', label: '210.000' },
    { value: '220000', label: '220.000' },
    { value: '240000', label: '240.000' },
    { value: '260000', label: '260.000' },
    { value: '280000', label: '280.000' },
    { value: '300000', label: '300.000' },
    { value: '320000', label: '320.000' },
    { value: '340000', label: '340.000' },
    { value: '360000', label: '360.000' },
    { value: '380000', label: '380.000' },
    { value: '400000', label: '400.000' },
    { value: '420000', label: '420.000' },
    { value: '440000', label: '440.000' },
    { value: '460000', label: '460.000' },
    { value: '480000', label: '480.000' },
    { value: '500000', label: '500.000' },
    { value: '520000', label: '520.000' },
    { value: '540000', label: '540.000' },
    { value: '560000', label: '560.000' },
    { value: '580000', label: '580.000' },
    { value: '600000', label: '600.000' },
    { value: '620000', label: '620.000' },
    { value: '640000', label: '640.000' },
    { value: '650000', label: '660.000' },
    { value: '680000', label: '680.000' },
    { value: '700000', label: '700.000' },
    { value: '720000', label: '720.000' },
    { value: '740000', label: '740.000' },
    { value: '760000', label: '760.000' },
    { value: '780000', label: '780.000' },
    { value: '800000', label: '800.000' },
    { value: '820000', label: '820.000' },
    { value: '840000', label: '840.000' },
    { value: '860000', label: '860.000' },
    { value: '880000', label: '880.000' },
    { value: '900000', label: '900.000' },
    { value: '920000', label: '920.000' },
    { value: '940000', label: '940.000' },
    { value: '950000', label: '960.000' },
    { value: '980000', label: '980.000' },
    { value: '1000000', label: '1.000.000' },
    { value: '1020000', label: '1.020.000' },
    { value: '1040000', label: '1.040.000' },
    { value: '1060000', label: '1.060.000' },
     { value: '1080000', label: '1.080.000' },
      { value: '1100000', label: '1.100.000' },
       { value: '1120000', label: '1.120.000' },
        { value: '1140000', label: '1.140.000' },
         { value: '1160000', label: '1.160.000' },
          { value: '1180000', label: '1.180.000' },
           { value: '1200000', label: '1.200.000' }
]



export const optionsMontosOtros = [
    { value: '320000', label: '320.000' },
    { value: '300000', label: '300.000' },
    { value: '280000', label: '280.000' },
    { value: '260000', label: '260.000' },
    { value: '250000', label: '250.000' },
    { value: '240000', label: '240.000' },
    { value: '230000', label: '230.000' },
    { value: '220000', label: '220.000' },
    { value: '210000', label: '210.000' },
    { value: '200000', label: '200.000' },
    { value: '190000', label: '190.000' },
    { value: '180000', label: '180.000' },
    { value: '170000', label: '170.000' },
    { value: '160000', label: '160.000' },
    { value: '150000', label: '150.000' },
    { value: '140000', label: '140.000' },
    { value: '130000', label: '130.000' },
    { value: '120000', label: '120.000' },
    { value: '110000', label: '110.000' },
    { value: '100000', label: '100.000' },
    { value: '90000', label: '90.000' },
    { value: '80000', label: '80.000' },
    { value: '70000', label: '70.000' },
    { value: '60000', label: '60.000' },
    { value: '50000', label: '50.000' },
    { value: '40000', label: '40.000' },
    { value: '30000', label: '30.000' },
    { value: '20000', label: '20.000' },
    { value: '10000', label: '10.000' },
    { value: '5000', label: '5.000' }
]


const optionsMontosEntidadPmi = [
    { value: '5000', label: '5.000' },
    { value: '10000', label: '10.000' },
    { value: '20000', label: '20.000' },
    { value: '40000', label: '40.000' },
    { value: '60000', label: '60.000' },
    { value: '80000', label: '80.000' },
    { value: '100000', label: '100.000' },
    { value: '120000', label: '120.000' },
    { value: '140000', label: '140.000' },
    { value: '160000', label: '160.000' },
    { value: '180000', label: '180.000' },
    { value: '200000', label: '200.000' },
    { value: '210000', label: '210.000' },
    { value: '220000', label: '220.000' },
    { value: '240000', label: '240.000' },
    { value: '260000', label: '260.000' },
    { value: '280000', label: '280.000' },
    { value: '300000', label: '300.000' },
    { value: '320000', label: '320.000' },
    { value: '340000', label: '340.000' },
    { value: '360000', label: '360.000' },
    { value: '380000', label: '380.000' },
    { value: '400000', label: '400.000' },
    { value: '420000', label: '420.000' },
    { value: '440000', label: '440.000' },
    { value: '460000', label: '460.000' },
    { value: '480000', label: '480.000' },
    { value: '500000', label: '500.000' },
    { value: '520000', label: '520.000' },
    { value: '540000', label: '540.000' },
    { value: '560000', label: '560.000' },
    { value: '580000', label: '580.000' },
    { value: '600000', label: '600.000' },
    { value: '620000', label: '620.000' },
    { value: '640000', label: '640.000' },
    { value: '650000', label: '660.000' },
    { value: '680000', label: '680.000' },
    { value: '700000', label: '700.000' },
    { value: '720000', label: '720.000' },
    { value: '740000', label: '740.000' },
    { value: '760000', label: '760.000' },
    { value: '780000', label: '780.000' },
    { value: '800000', label: '800.000' },
    { value: '820000', label: '820.000' },
    { value: '840000', label: '840.000' },
    { value: '860000', label: '860.000' },
    { value: '870000', label: '870.000' }
]

const optionsMontosEntidadPmi2000 = [
    { value: '5000', label: '5.000' },
    { value: '20000', label: '20.000' },
    { value: '40000', label: '40.000' },
    { value: '60000', label: '60.000' },
    { value: '80000', label: '80.000' },
    { value: '100000', label: '100.000' },
    { value: '120000', label: '120.000' },
    { value: '140000', label: '140.000' },
    { value: '160000', label: '160.000' },
    { value: '180000', label: '180.000' },
    { value: '200000', label: '200.000' },
    { value: '210000', label: '210.000' },
    { value: '220000', label: '220.000' },
    { value: '240000', label: '240.000' },
    { value: '260000', label: '260.000' },
    { value: '280000', label: '280.000' },
    { value: '300000', label: '300.000' },
    { value: '320000', label: '320.000' },
    { value: '340000', label: '340.000' },
    { value: '360000', label: '360.000' },
    { value: '380000', label: '380.000' },
    { value: '400000', label: '400.000' },
    { value: '420000', label: '420.000' },
    { value: '440000', label: '440.000' },
    { value: '460000', label: '460.000' },
    { value: '480000', label: '480.000' },
    { value: '500000', label: '500.000' },
    { value: '520000', label: '520.000' },
    { value: '540000', label: '540.000' },
    { value: '560000', label: '560.000' },
    { value: '580000', label: '580.000' },
    { value: '600000', label: '600.000' },
    { value: '620000', label: '620.000' },
    { value: '640000', label: '640.000' },
    { value: '660000', label: '660.000' },
    { value: '680000', label: '680.000' },
    { value: '700000', label: '700.000' },
    { value: '720000', label: '720.000' },
    { value: '740000', label: '740.000' },
    { value: '760000', label: '760.000' },
    { value: '780000', label: '780.000' },
    { value: '800000', label: '800.000' },
    { value: '820000', label: '820.000' },
    { value: '840000', label: '840.000' },
    { value: '860000', label: '860.000' },
    { value: '880000', label: '880.000' },
    { value: '900000', label: '900.000' },
    { value: '920000', label: '920.000' },
    { value: '940000', label: '940.000' },
    { value: '960000', label: '960.000' },
    { value: '980000', label: '980.000' },
    { value: '1000000', label: '1.000.000' },
    { value: '1020000', label: '1.020.000' },
    { value: '1040000', label: '1.040.000' },
    { value: '1060000', label: '1.060.000' },
    { value: '1080000', label: '1.080.000' },
    { value: '1100000', label: '1.100.000' },
    { value: '1120000', label: '1.120.000' },
    { value: '1140000', label: '1.140.000' },
    { value: '1160000', label: '1.160.000' },
    { value: '1180000', label: '1.180.000' },
    { value: '1200000', label: '1.200.000' },
    { value: '1220000', label: '1.220.000' },
    { value: '1240000', label: '1.240.000' },
    { value: '1260000', label: '1.260.000' },
    { value: '1280000', label: '1.280.000' },
    { value: '1300000', label: '1.300.000' },
    { value: '1320000', label: '1.320.000' },
    { value: '1340000', label: '1.340.000' },
    { value: '1350000', label: '1.350.000' }
]

const optionsMontosEntidadPmi3000 = [
    { value: '5000', label: '5.000' },
    { value: '20000', label: '20.000' },
    { value: '40000', label: '40.000' },
    { value: '60000', label: '60.000' },
    { value: '80000', label: '80.000' },
    { value: '100000', label: '100.000' },
    { value: '120000', label: '120.000' },
    { value: '140000', label: '140.000' },
    { value: '160000', label: '160.000' },
    { value: '180000', label: '180.000' },
    { value: '200000', label: '200.000' },
    { value: '210000', label: '210.000' },
    { value: '220000', label: '220.000' },
    { value: '240000', label: '240.000' },
    { value: '260000', label: '260.000' },
    { value: '280000', label: '280.000' },
    { value: '300000', label: '300.000' },
    { value: '320000', label: '320.000' },
    { value: '340000', label: '340.000' },
    { value: '360000', label: '360.000' },
    { value: '380000', label: '380.000' },
    { value: '400000', label: '400.000' },
    { value: '420000', label: '420.000' },
    { value: '440000', label: '440.000' },
    { value: '460000', label: '460.000' },
    { value: '480000', label: '480.000' },
    { value: '500000', label: '500.000' },
    { value: '520000', label: '520.000' },
    { value: '540000', label: '540.000' },
    { value: '560000', label: '560.000' },
    { value: '580000', label: '580.000' },
    { value: '600000', label: '600.000' },
    { value: '620000', label: '620.000' },
    { value: '640000', label: '640.000' },
    { value: '660000', label: '660.000' },
    { value: '680000', label: '680.000' },
    { value: '700000', label: '700.000' },
    { value: '720000', label: '720.000' },
    { value: '740000', label: '740.000' },
    { value: '760000', label: '760.000' },
    { value: '780000', label: '780.000' },
    { value: '800000', label: '800.000' },
    { value: '820000', label: '820.000' },
    { value: '840000', label: '840.000' },
    { value: '860000', label: '860.000' },
    { value: '880000', label: '880.000' },
    { value: '900000', label: '900.000' },
    { value: '920000', label: '920.000' },
    { value: '940000', label: '940.000' },
    { value: '960000', label: '960.000' },
    { value: '980000', label: '980.000' },
    { value: '1000000', label: '1.000.000' },
    { value: '1020000', label: '1.020.000' },
    { value: '1040000', label: '1.040.000' },
    { value: '1060000', label: '1.060.000' },
    { value: '1080000', label: '1.080.000' },
    { value: '1100000', label: '1.100.000' },
    { value: '1120000', label: '1.120.000' },
    { value: '1140000', label: '1.140.000' },
    { value: '1160000', label: '1.160.000' },
    { value: '1180000', label: '1.180.000' },
    { value: '1200000', label: '1.200.000' },
    { value: '1220000', label: '1.220.000' },
    { value: '1240000', label: '1.240.000' },
    { value: '1260000', label: '1.260.000' },
    { value: '1280000', label: '1.280.000' },
    { value: '1300000', label: '1.300.000' },
    { value: '1320000', label: '1.320.000' },
    { value: '1340000', label: '1.340.000' },
    { value: '1360000', label: '1.360.000' },
    { value: '1380000', label: '1.380.000' },
    { value: '1400000', label: '1.400.000' },
    { value: '1420000', label: '1.420.000' },
    { value: '1440000', label: '1.440.000' },
    { value: '1460000', label: '1.460.000' },
    { value: '1480000', label: '1.480.000' },
    { value: '1500000', label: '1.500.000' },
    { value: '1520000', label: '1.520.000' },
    { value: '1540000', label: '1.540.000' },
    { value: '1560000', label: '1.560.000' },
    { value: '1580000', label: '1.580.000' },
    { value: '1600000', label: '1.600.000' },
    { value: '1650000', label: '1.650.000' },
    { value: '1700000', label: '1.700.000' },
    { value: '1750000', label: '1.750.000' },
    { value: '1800000', label: '1.800.000' },
    { value: '1850000', label: '1.850.000' },
    { value: '1900000', label: '1.900.000' },
    { value: '1950000', label: '1.950.000' },
    { value: '2000000', label: '2.000.000' }
]

const montosPmi = optionsMontosPmi.reverse();
const montosPmi2000 = optionsMontosPmi2000.reverse();
const montosPmi3000 = optionsMontosPmi3000.reverse();

const montosPmiEntidad = optionsMontosEntidadPmi.reverse();
const montos2000Entidad = optionsMontosEntidadPmi2000.reverse();
const montos3000Entidad = optionsMontosEntidadPmi3000.reverse();

export { montosPmi, montosPmi2000, montosPmi3000, montosPmiEntidad, montos2000Entidad, montos3000Entidad }